class Util {
    public flatMap<T, R>(collection: T[], mapFunction: (a: T) => R[]): R[] {
        return collection
            .map((x) => mapFunction(x))
            .reduce((arr, v) => (arr.push(...v), arr), []);
    }

    public groupBy(xs: any[], key: string) {
        return xs.reduce((rv, x) => {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }
}

export const util = new Util();
